import React from "react";
import UsersListCheckboxRow from "../UsersListCheckboxRow";
import { ACHTemplate, UserAccount } from "model";

/**
 * @function UsersListWidget
 * @return {React.Component}
 * @exported true
 * @description This is the users list widget used for the DenyUsersPage.
 */
export default function UsersListWidget(props) {
    const userAccounts = props.userAccounts ?? [];
    const achTemplates = props.achTemplates ?? [];
    const selectedACHTemplateID = props.selectedACHTemplateID ?? "";
    const selectedUserAccountID = props.selectedUserAccountID ?? "";
    const onDenyAllClick = props.onDenyAllClick ?? undefined;
    const onCheckboxClick = props.onCheckboxClick ?? undefined;
    const allACHTemplateIDs = achTemplates.reduce((acc, item) => {
        acc.push(item.id);
        return acc;
    }, []);
    const selectedACHTemplate = achTemplates.filter(item => item.id === selectedACHTemplateID)[0] ?? undefined; 
    const selectedUserAccount = userAccounts.filter(item => item.id === selectedUserAccountID)[0] ?? undefined;

    const allUserAccountsHaveThisACHTemplateSelected = () => {
        return selectedACHTemplate.denyAccessToUserIDs.filter(item => item !== "").length === userAccounts.length;
    }

    const currentUserAccountHasAllACHTemplateIDsSelected = () => {
        for(let i = 0; i < achTemplates.length; i++) {
            const achTemplate = achTemplates[i];
            if(!achTemplate.denyAccessToUserIDs.includes(selectedUserAccount.id)) {
                return false;
            }
        }
        return true;
    }

    let denyAllChecked = false;
    if(selectedACHTemplateID !== "") {
        denyAllChecked = allUserAccountsHaveThisACHTemplateSelected();
    } else if(selectedUserAccountID !== "") {
        denyAllChecked = currentUserAccountHasAllACHTemplateIDsSelected();
    }

    // An ach template id has to be selected to see user account rows.
    let userAccountRows = userAccounts.reduce((acc, item) => {
        if(selectedACHTemplate) {
            const fullName = UserAccount.userIsCurrentUser(item) ? `${ item.fullName } (You)` : item.fullName;
            const checked = selectedACHTemplate.denyAccessToUserIDs.includes(item.id);
            acc.push(<UsersListCheckboxRow key={ item.id } userAccount={ item } username={ fullName }
            onCheckboxClick={ onCheckboxClick } checked={ checked } />);
        }
        return acc;
    }, []);

    // A user account id has to be selected to see ach template rows.
    let achTemplateRows = achTemplates.reduce((acc, item) => {
        if(selectedUserAccount) {
            
            const checked = item.denyAccessToUserIDs.includes(selectedUserAccount.id);
            acc.push(<UsersListCheckboxRow key={ item.id } achTemplate={ item } username={ item.name } 
            onCheckboxClick={ onCheckboxClick } checked={ checked } />);
        }
        return acc;
    }, []);

    return (
        <div className="users-list-widget">
            <div className="user-list-widget-container flex-container flex-vertical">
                <UsersListCheckboxRow username="Deny All" achTemplate={ selectedACHTemplate } userAccount={ selectedUserAccount } onDenyAllClick={ onDenyAllClick } checked={ denyAllChecked } />
                { userAccountRows }
                { achTemplateRows }
            </div>
        </div>
    )
}
